var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-rule"},[_c('div',{staticClass:"rule-tit"},[_vm._v(" 排号说明 ")]),_c('div',{staticClass:"ruel_content"},[_vm._v(" "+_vm._s(_vm.ruledata.introduction)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }